import {
  Box,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { STYLE_CONSTANTS } from '../../../constants';
import { useAppDispatch, useAppSelector } from '../../../redux-store/hooks';
import {
  FloorViewer, PlacesViewer, TablesViewer
} from '../../client-info';
import { RestaurantTable } from '../../../components';
import React, { FC } from 'react';
import { ITables } from '../../../all-types';




const SCROLL_STYLES = {
  overflowY: 'auto',
  //borderRight: `1px solid black`,
  //borderLeft: `1px solid black`,
  scrollbarWidth: 'thin',
  position: "relative",
  overflowX: "hidden",
}

export interface ItableAssignerProps {
  onTableSelect: (tableName: ITables) => void;
}

const TableAssigner: FC<ItableAssignerProps> = ({ onTableSelect }) => {
  const theme = useTheme();
  const tables = useAppSelector(state => state.clientInfo.data.tableManager.tables);
  const places = useAppSelector(state => state.clientInfo.data.tableManager.places);
  const floors = useAppSelector(state => state.clientInfo.data.tableManager.noOffloors);
  const activeBills = useAppSelector(state => state.billing.activeBills);


  const STANDARD_HEADER_HEIGHT = useAppSelector(state => state.ui.STANDARD_HEADER_HEIGHT);
  const OCCUPIED_HEIGHT = STANDARD_HEADER_HEIGHT + STYLE_CONSTANTS.SETTING_BOTTOM_BAR_HEIGHT;
  const VIEW_HEIGHT = `calc(100vh - ${OCCUPIED_HEIGHT}px)`
  const [selectedPlace, setSelectedPlace] = React.useState<string>("All");
  const [selectedFloor, setSelectedFloor] = React.useState<number>(0);
  const filteredTables = Object.values(tables).filter(t => (selectedPlace !== "All" ? t.place === selectedPlace : true) && (selectedFloor != 0 ? t.floorNo === selectedFloor : true));

  const getUniqueTableName = (t: ITables) => {
    return t.tableName.concat(String(t.tableNo)).concat(String(t.floorNo));
  }

  const isTableFree = (t: ITables) => { 
    const uniqueName = getUniqueTableName(t);
    if(activeBills[uniqueName]) {
      return false;
    }
    return true;
  }

  return (
    <Box display="flex" flexDirection={"column"} flex={1}>
      <Stack flexDirection={"row"} flex={1}>
        <Stack flex={1} height={VIEW_HEIGHT} sx={{
          ...SCROLL_STYLES,
          minWidth: "150px"
        }}>
          <PlacesViewer places={places} selectedPlace={selectedPlace} setSelectedPlace={setSelectedPlace} />
        </Stack>
        <Stack flex={8} height={VIEW_HEIGHT} sx={{ ...SCROLL_STYLES }}>
          <Stack flexDirection={"row"} justifyContent={"center"} gap={2} mb={1}>
            <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%", 
                  backgroundColor: theme.palette.available.main, 
                }}
              />
              <Typography variant="h6">Available</Typography>
            </Stack>
            <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%", 
                  backgroundColor: theme.palette.occupied.main, 
                }}
              />
              <Typography variant="h6">Occupied</Typography>
            </Stack>
            <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%", 
                  backgroundColor: theme.palette.offline.main, 
                }}
              />
              <Typography variant="h6">Unavailable</Typography>
            </Stack>

          </Stack>
          <Stack flex={1} flexDirection={"row"} sx={{ flexWrap: "wrap", alignItems: "center", justifyContent: "center" }} gap={2}>
            {(filteredTables && Object.values(filteredTables).length > 0) && Object.values(filteredTables)?.map(t => (
              <Stack key={t.tableId} style={{cursor: "pointer"}}>
                <RestaurantTable table={t} onTableSelect={onTableSelect} isFree={isTableFree(t) } />
              </Stack>
            ))}
          </Stack>
        </Stack>
        <Stack flex={1} height={VIEW_HEIGHT} sx={{
          ...SCROLL_STYLES,
          minWidth: "150px"
        }}>
          <FloorViewer floors={floors} selectedFloor={selectedFloor} setSelectedFloor={setSelectedFloor} />
        </Stack>
      </Stack>
    </Box>
  );
};

export { TableAssigner };

